<template>
  <div class="form-group d-flex">
    <k-input
      ref="textInputInGrid"
      type="text"
      :class="{'form-control-sm' : !highlightTextbox, 'form-control-sm invalid' : highlightTextbox, 'faded-text': fadedText}"
      v-model="textInput"
      :disabled="!this.edit"
      v-kendo-validator="validateInput()"
      :tabIndex="this.edit ? tabIndex : -1"
      :maxLength="maxLength"
    ></k-input>
    <div class="nav-item nav-icon">
      <a class="cursor-pointer" id="navbarHelp" data-bs-toggle="help" aria-expanded="false">
        <i class="icon-attention text-danger" v-b-tooltip.hover :title="this.validationMsg" v-if="validationMsg !== ''"></i>
      </a>
    </div>
  </div>
</template>

<script>
import kendo from "@progress/kendo-ui";
export default {
  name: "text-input-in-grid",
  props: {
    value: String,
    edit: Boolean,
    tabIndex: Number,
    maxLength: {
      type: Number,
      default: null
    },
    fadedText: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      textInput: "",
      highlightTextbox: false,
      validationMsg: "",
      backUpValue: ""
    }
  },
  mounted() {
    this.textInput = String(this.value);
    this.backUpValue = String(this.value);
  },
  computed: {
  },
  watch: {
    textInput: function() {
      const validator = kendo.jQuery(this.$refs.textInputInGrid.$el).getKendoValidator();
      var ele = kendo.jQuery(this.$refs.textInputInGrid.$el)[0].children[0];
      validator.validateInput(ele);
    },
    edit: function() {
      if (this.edit) {
        this.backUpValue = this.textInput;
      }
      else {
        this.highlightTextbox = false;
        this.validationMsg = "";
        this.textInput = this.backUpValue;
      }
    },
    value: function(newValue) {
      this.textInput = String(newValue);
      this.backUpValue = String(newValue);
    }
  },
  methods: {
    validateInput: function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      return {
        rules: {
          invalid: function () {
            if (vm.textInput.toString().trim() === "") {
              vm.highlightTextbox = true;
              vm.validationMsg = "Invalid input"
            }
            else {
              vm.highlightTextbox = false;
              vm.validationMsg = "";
            }
            return true;
          }
        },
        messages: {
            invalid: ""
        }
      }
    }
  }
}
</script>
